












import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import { IBookInfoInput } from '@/modules/Book/interfaces/book-form'

@Component({
  components: {
    AppTextField
  }
})
export default class BookFormInfo extends Vue {
  @Prop({ type: Object as () => IBookInfoInput }) value!: IBookInfoInput

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
